"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compatibility = exports.ModalTextPartial = exports.ModalText = exports.ModalDialogTextPartial = exports.ModalDialogText = void 0;
var t = __importStar(require("io-ts"));
var modalDialogTextProps = { header: t.string, body: t.string };
exports.ModalDialogText = t.type(modalDialogTextProps);
exports.ModalDialogTextPartial = t.partial(modalDialogTextProps);
exports.ModalText = t.type({
    qrCodeDialogText: exports.ModalDialogText,
    incompatibleDeviceDialogText: exports.ModalDialogText,
    arErrorDialogText: exports.ModalDialogText,
    arLoadingProgressDialogHeader: t.string,
    /**  The text displayed on the 'View in room' button */
    buttonText: t.string,
    /** The text displayed above the button */
    buttonExplainerText: t.string,
    /** The text used for the header for the drawer on desktop and the view in Ar button */
    viewInAr: t.string,
    /** The call to action text below the QR code */
    qrCtaText: t.string,
    addToCartButton: t.string,
});
exports.ModalTextPartial = t.partial({
    qrCodeDialogText: exports.ModalDialogTextPartial,
    incompatibleDeviceDialogText: exports.ModalDialogTextPartial,
    arErrorDialogText: exports.ModalDialogTextPartial,
    arLoadingProgressDialogHeader: t.string,
    /**  The text displayed on the 'View in room' button */
    buttonText: t.string,
    /** The text displayed above the button */
    buttonExplainerText: t.string,
    /** The text used for the header for the drawer on desktop and the view in Ar button */
    viewInAr: t.string,
    /** The call to action text below the QR code */
    qrCtaText: t.string,
    addToCartButton: t.string,
});
/**
 * The possible states of AR Compatibility
 */
var Compatibility;
(function (Compatibility) {
    /** Incompatible because we are on Desktop */
    Compatibility["IncompatibleDesktop"] = "IncompatibleDesktop";
    /** Incompatible on mobile with the wrong browser */
    Compatibility["IncompatibleBrowser"] = "IncompatibleBrowser";
    /** Assumed Compatible */
    Compatibility["Compatible"] = "Compatible";
})(Compatibility = exports.Compatibility || (exports.Compatibility = {}));
